import moment from "moment";

import { isIncreaseOrderType } from "domain/synthetics/orders";

export function getTradeHistorySide(isLong: boolean, orderType: number): "buy" | "sell" {
  const isIncrease = isIncreaseOrderType(orderType);
  if (isIncrease) {
    return isLong ? "buy" : "sell";
  }

  return isLong ? "sell" : "buy";
}

export function formatTradeTime(value: string | number, source: "iso" | "unix") {
  if (source === "unix") {
    return moment.unix(Number(value)).format("HH:mm:ss");
  }

  return moment(value).format("HH:mm:ss");
}
